import { useSiteConfig, useSiteConfigDispatch } from '../../context/SiteConfigContext';
import styles from './LanguageSwitcher.module.css';

const languages = [
  { code: 'es', label: 'ES' },
  { code: 'en', label: 'EN' },
  { code: 'pt', label: 'PT' },
  { code: 'ja', label: 'JA' },
  { code: 'ko', label: 'KO' },
  { code: 'zh', label: 'ZH' },
  { code: 'ru', label: 'RU' },
];

function LanguageSwitcher() {
  const { meta } = useSiteConfig();
  const dispatch = useSiteConfigDispatch();

  return (
    <div className={styles.switcher}>
      {languages.map(({ code, label }) => (
        <button
          key={code}
          className={`${styles.btn} ${meta.lang === code ? styles.active : ''}`}
          onClick={() => dispatch({ type: 'SET_LANGUAGE', lang: code })}
          aria-label={`Switch to ${label}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
